import HasAgent from '../../cards/has-agent';
import { Branch, Card } from '../../components/deck';

const shouldAskAgent = (model) => {
  switch (model.getIn(['loan', 'scenario'])) {
    case 'RefiFull':
    case 'RefiQualify':
      return false;
    case 'Preapproval':
      return true;
    default:
      return !model.getIn(['loan', 'acceptedOffer']);
  }
};

export default (continuation) =>
  Branch(
    {
      askAgent: Card(HasAgent)
    },
    ({ model }) => (shouldAskAgent(model) ? 'askAgent' : null),
    continuation
  );



// WEBPACK FOOTER //
// ./src/decks/branches/has-agent.js